import { get, patch, post, remove } from 'vio-libs';
export function getContacts(organization, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`contacts?organization=${organization}`);
    }
    return get(`v1/${organization}/contacts`, undefined, true);
}
export function postNewContact(organization, contact, consumerAPI = false) {
    if (!consumerAPI) {
        return post(`contacts?organization=${organization}`, {
            data: Object.assign({}, contact)
        });
    }
    return post(`v1/${organization}/contacts`, {
        data: Object.assign({}, contact)
    }, true);
}
export function patchExistingContact(organization, contactId, update, consumerAPI = false) {
    if (!consumerAPI) {
        return patch(`contacts?organization=${organization}`, {
            data: {
                contact_id: contactId,
                update
            }
        });
    }
    return patch(`v1/${organization}/contacts/${contactId}`, {
        data: Object.assign({}, update)
    }, true);
}
export function removeContact(organization, contactId, consumerAPI = false) {
    if (!consumerAPI) {
        return remove(`contacts?organization=${organization}`, {
            data: {
                contact_id: contactId
            }
        });
    }
    return remove(`v1/${organization}/contacts/${contactId}`, undefined, true);
}
